/* HelloSpicy — scripts extraits de sections/hs-hero.liquid (audit A23 : sortis du HTML pour l'alléger et les mettre en cache). */
(function(){
    var root = document.querySelector('[data-hs-hero]');
    if (!root) return;
    var vp = root.querySelector('[data-hs-hero-viewport]');
    if (!vp) return;

    // Le comptage se fait sur les SLIDES, pas sur les pastilles : les compter
    // reviendrait a couper le defilement automatique des qu'on les masque.
    var slides = [].slice.call(root.querySelectorAll('.hs-hero__slide'));
    if (slides.length < 2) return;
    var dots = [].slice.call(root.querySelectorAll('[data-hs-hero-dot]'));

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function indexCourant(){ return Math.round(vp.scrollLeft / vp.clientWidth); }

    function majPastilles(){
      if (!dots.length) return;
      var i = indexCourant();
      dots.forEach(function(d, n){
        if (n === i) { d.setAttribute('aria-current', 'true'); }
        else { d.removeAttribute('aria-current'); }
      });
    }

    function allerA(i){
      vp.scrollTo({ left: i * vp.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    dots.forEach(function(d, n){
      d.addEventListener('click', function(){ allerA(n); arreter(); });
    });

    // ---- Audit A12 : défilement automatique (7 s mini), pause au survol et au
    // focus clavier. (Bouton pause retiré à la demande ; le code reste inerte
    // s'il n'y a pas de bouton dans la section.) ------------------------------
    var minuteur = null;
    var pauseUtilisateur = false;   // bouton pause, ou interaction tactile/clic
    var pauseSurvol = false;
    var pauseFocus = false;
    var tourTermine = false;        // un seul tour : 1 → … → dernière → retour à la 1re, puis arrêt
    var btnPause = root.querySelector('[data-hs-hero-pause]');
    var autoOk = !reduce && root.getAttribute('data-autoplay') === 'true';

    function majBouton(){
      if (!btnPause) return;
      btnPause.setAttribute('aria-pressed', pauseUtilisateur ? 'true' : 'false');
      btnPause.setAttribute('aria-label', pauseUtilisateur ? 'Reprendre le défilement automatique' : 'Mettre en pause le défilement automatique');
      btnPause.classList.toggle('is-paused', pauseUtilisateur);
    }
    function tourner(){
      if (minuteur) return;
      if (!autoOk || tourTermine || pauseUtilisateur || pauseSurvol || pauseFocus) return;
      var delai = Math.max(7000, parseInt(root.getAttribute('data-delay'), 10) || 7000);
      minuteur = setInterval(function(){
        if (document.hidden) return;
        var suivant = (indexCourant() + 1) % slides.length;
        allerA(suivant);
        // Demande du 26/09/2026 : le carrousel ne fait qu'UN tour. Arrivé de
        // nouveau sur la diapositive initiale, il s'arrête définitivement.
        if (suivant === 0) { tourTermine = true; suspendre(); }
      }, delai);
    }
    function suspendre(){ if (minuteur) { clearInterval(minuteur); minuteur = null; } }
    function demarrer(){ tourner(); }
    // Une interaction tactile / un clic sur une pastille = le visiteur prend la main :
    // défilement arrêté pour le reste de la visite (comportement d'origine).
    // ATTENTION : 'scroll' n'est VOLONTAIREMENT pas écouté - l'amorce mobile
    // produit un scroll programmatique qui tuerait l'autoplay dès le chargement.
    function arreter(){ pauseUtilisateur = true; suspendre(); majBouton(); }

    if (btnPause && autoOk) {
      btnPause.hidden = false;
      btnPause.addEventListener('click', function(){
        pauseUtilisateur = !pauseUtilisateur;
        majBouton();
        if (pauseUtilisateur) suspendre(); else tourner();
      });
    }

    vp.addEventListener('scroll', majPastilles, { passive: true });
    ['pointerdown','touchstart'].forEach(function(ev){
      vp.addEventListener(ev, arreter, { passive: true });
    });
    root.addEventListener('mouseenter', function(){ pauseSurvol = true; suspendre(); });
    root.addEventListener('mouseleave', function(){ pauseSurvol = false; tourner(); });
    root.addEventListener('focusin', function(){ pauseFocus = true; suspendre(); });
    root.addEventListener('focusout', function(e){
      if (e.relatedTarget && root.contains(e.relatedTarget)) return;
      pauseFocus = false; tourner();
    });

    // ---- REVISION 6 : amorce de defilement, mobile uniquement --------------
    // 26 px : assez pour laisser voir le bord de la diapositive suivante, trop
    // peu pour que Math.round(26/360) sorte de l'index 0 (les pastilles ne
    // bougent donc pas). Ne pas monter au-dela de la moitie de la largeur.
    var HS_AMORCE_PX = 26;
    var amorceJouee = false;

    function amorcer(){
      if (amorceJouee) return;
      if (reduce) return;
      if (root.getAttribute('data-amorce') !== 'true') return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      // Le visiteur a deja fait defiler : ne rien lui montrer qu'il sait deja.
      if (vp.scrollLeft > 2) { amorceJouee = true; return; }
      // Onglet en arriere-plan : le defilement doux y est suspendu, l'amorce
      // serait gaspillee. On attend le retour (voir plus bas).
      if (document.hidden) return;

      amorceJouee = true;
      var snapInitial = vp.style.scrollSnapType;
      // Sans cette suspension, `scroll-snap-type: x mandatory` re-aimante
      // instantanement la position intermediaire et l'amorce n'a pas lieu.
      vp.style.scrollSnapType = 'none';
      vp.scrollTo({ left: HS_AMORCE_PX, behavior: 'smooth' });
      setTimeout(function(){
        vp.scrollTo({ left: 0, behavior: 'smooth' });
        // On rend la main a la feuille de style (chaine vide), on ne reecrit
        // pas 'x mandatory' en dur.
        setTimeout(function(){ vp.style.scrollSnapType = snapInitial || ''; }, 500);
      }, 420);
    }

    function amorcerQuandVisible(){
      if (amorceJouee) return;
      if (document.hidden) return;
      setTimeout(amorcer, 900);
    }

    document.addEventListener('visibilitychange', function(){
      if (document.visibilityState === 'visible') amorcerQuandVisible();
    });

    majPastilles();
    demarrer();
    // 900 ms : laisse l'image LCP s'afficher et la page se stabiliser avant de
    // bouger quoi que ce soit sous les yeux du visiteur.
    amorcerQuandVisible();
  })();
